import React from 'react';
import DOMPurify from 'dompurify';
import parse from 'html-react-parser';
import * as styles from './SingleJobDescription.module.scss';

interface SingleJobDescriptionProps {
    htmlContent: string;
}


export const SingleJobDescription:React.FC<SingleJobDescriptionProps> = ({htmlContent}) => {
 
  function decodeHTMLEntities(text:string) {
    if(text){
      var entities = [
        ['amp', '&'],
        ['apos', '\''],
        ['#x27', '\''],
        ['#x2F', '/'],
        ['#39', '\''],
        ['#47', '/'],
        ['lt', '<'],
        ['gt', '>'],
        ['nbsp', ' '],
        ['quot', '"']
    ];

    for (var i = 0, max = entities.length; i < max; ++i)
        text = text.replace(new RegExp('&'+entities[i][0]+';', 'g'), entities[i][1]);
    }
    return text;
  }

  const dirtyHTML = decodeHTMLEntities(htmlContent)

  return (
    <div className={[styles['detail-container'], 'container'].join(" ")} id="detail-container">
      <div className={styles['description']}>
          <div dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(dirtyHTML)}}/>
      </div>
    </div>
  )
}